export const COMMON = {
    ApiCancelled: 'api cancelled',
    networkErrorMessage: 'Unable to load data, try a different network!',
    genericErrorMessage: 'Something went wrong !',
    unableToLoadData: 'Unable to load data.',
    OKAY: 'OKAY',
    GO_TO_ORDERS: 'GO TO ORDERS',

};
